import log from "loglevel";
import { toast } from "react-toastify";

// Default toast configuration
export const toastConfig = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
};

let toastId = "";

/**
 * Display a global toast message with customizable options
 * 
 * @param {string} message - The message to display
 * @param {string} type - Toast type: 'info', 'success', 'error', 'warning'
 * @param {boolean} prevent_duplicate - Whether to prevent duplicate toasts
 * @param {Object} customConfig - Optional custom toast configuration
 * @param {number|boolean} customConfig.autoClose - Custom autoClose duration in ms, or false to disable
 * @param {string} customConfig.position - Toast position
 * @param {boolean} customConfig.hideProgressBar - Whether to hide progress bar
 * @returns {string|null} - The toast ID if created, null if prevented as duplicate
 */
export default function displayGlobalMessage(
  message, 
  type = 'info', 
  prevent_duplicate = false,
  customConfig = {}
) {
  // Prevent duplicate if requested and message matches last toast
  if (prevent_duplicate && toastId === message) {
    return null;
  }
  
  // Store message as the last toast ID
  toastId = message;
  
  // Merge default config with any custom options
  const finalConfig = {
    ...toastConfig,
    ...customConfig,
    type: type,
  };

  log.log("Toast Config", finalConfig);
  
  // Create and return the toast
  return toast(message, finalConfig);
}